import React from 'react';
import Filter from './Filter.jsx';
import { useStateValue } from './AppContext.jsx';

function Filters() {
  const [ {filters}, dispatch ] = useStateValue();

  return (
    <div
      className="filters">
      {filters.map( (item, index) => (
        <Filter
          key={index}
          index={index}
          value={item.value}
          label={item.label}
          options={item.options}
          onChange={(value) => {
            dispatch({
              type: 'updateFilter',
              index: index,
              value: value
            })}}
          />
        ))}
    </div>
  );
}

export default Filters;